import { j as r } from "./atoms-v218.js";
import { forwardRef as I } from "react";
import { Button as k, Link as F } from "./atoms-v2704.js";
import { Icon as d } from "./atoms-v217.js";
import { ICON_SIZE_MAP as b } from "./atoms-v2705.js";
const z = I(
  ({
    ariaHidden: s = !1,
    ariaLabel: o,
    buttonType: f = "button",
    children: p,
    className: a,
    colorTheme: i = "light",
    disabled: t,
    href: $ = void 0,
    icon: e = void 0,
    iconPosition: m = "after",
    id: h,
    onClick: c,
    renderAsButton: g = !1,
    size: n = "inherit",
    target: u
  }, l) => {
    const x = () => {
      const j = b[n];
      return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        e && m === "before" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(d, { name: e, size: j }),
          " "
        ] }),
        p,
        e && m === "after" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          " ",
          /* @__PURE__ */ r.jsx(d, { name: e, size: j })
        ] })
      ] });
    };
    return /* @__PURE__ */ r.jsx(r.Fragment, { children: g ? /* @__PURE__ */ r.jsx(
      k,
      {
        $colorTheme: i,
        $disabled: t,
        $hasIcon: !!e,
        $size: n,
        "aria-hidden": s,
        "aria-label": o,
        className: a,
        disabled: t,
        id: h,
        onClick: c,
        ref: l,
        type: f,
        children: /* @__PURE__ */ r.jsx(x, {})
      }
    ) : /* @__PURE__ */ r.jsx(
      F,
      {
        $colorTheme: i,
        $disabled: t,
        $hasIcon: !!e,
        $size: n,
        "aria-hidden": s,
        "aria-label": o,
        className: a,
        href: $,
        id: h,
        ref: l,
        target: u,
        children: /* @__PURE__ */ r.jsx(x, {})
      }
    ) });
  }
);
z.displayName = "Link";
export {
  z as Link
};
